import React from 'react';
import { ReactComponent as NewOrderSvg } from '../../images/calendarCreateIcons/mb-new-order.svg';
import { ReactComponent as NoteSvg } from '../../images/calendarCreateIcons/mb-note.svg';
import { ReactComponent as AvailabilitySvg } from '../../images/calendarCreateIcons/mb-availability.svg';
import { ReactComponent as ShiftSvg } from '../../images/calendarCreateIcons/mb-shift.svg';
import { ReactComponent as BlockAreaSvg } from '../../images/calendarCreateIcons/mb-block-area.svg';

export enum CalendarCreateIconName {
  NewOrder = 'newOrder',
  Note = 'note',
  Availability = 'availability',
  Shift = 'shift',
  BlockArea = 'blockArea',
}

const CALENDAR_CREATE_ICONS: Record<CalendarCreateIconName, React.FC<React.SVGProps<SVGSVGElement>>> = {
  [CalendarCreateIconName.NewOrder]: NewOrderSvg,
  [CalendarCreateIconName.Note]: NoteSvg,
  [CalendarCreateIconName.Availability]: AvailabilitySvg,
  [CalendarCreateIconName.Shift]: ShiftSvg,
  [CalendarCreateIconName.BlockArea]: BlockAreaSvg,
};

/** Brand icons for the calendar's create actions (slot menu, mobile add menu): a soft wash behind the text color. */
export const CalendarCreateIcon = ({ name, size = 24 }: { name: CalendarCreateIconName; size?: number }) => {
  const Svg = CALENDAR_CREATE_ICONS[name];
  return (
    <Svg width={size} height={size} aria-hidden="true" focusable="false" style={{ flexShrink: 0, display: 'block' }} />
  );
};
